<template>
  <div>
    <div id="data-list-list-view" class="data-list-container mt-5">
      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="transactions.last_page" v-model="transactions.current_page"></vs-pagination>
        </div>
      </div>

      <vs-table
        ref="table"
        noDataText="Nenhum item encontrado no período selecionado"
        :data="data"
        :sst="true"
        :stripe="true"
      >
        <template slot="thead">
          <vs-th>NÚMERO</vs-th>
          <vs-th>VALOR</vs-th>
          <vs-th>SITUAÇÃO</vs-th>
          <vs-th>DATA</vs-th>
          <vs-th>HORA</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td :data="data[idx].number">
              {{ data[idx].number }}
            </vs-td>
            <vs-td :data="data[idx].amount">{{ data[idx].amount | money(data[idx].currency) }}</vs-td>
            <vs-td :data="data[idx].status">{{ data[idx].status }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatDate }}</vs-td>
            <vs-td :data="data[idx].created_at">{{ data[idx].created_at | formatTime }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-center">
        <div>
          <vs-pagination :max="10" :total="transactions.last_page" v-model="transactions.current_page"></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transactions: {
        current_page: 1,
        last_page: 1
      },
      data: [],
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.$vs.loading()

      this.$api
          .get('/api/v1/affiliate/transactions', {
            params: {
              page: this.transactions.current_page,
            }
          })
          .then(response => {
            this.$vs.loading.close()
            this.data = response.data.data
            this.transactions = response.data
          })
    },
  },

  watch: {
    'transactions.current_page'() {
      this.load()
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          bg-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
